import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PartsOrder, PartsOrderStatus } from '@contracts/interfaces/parts-order.interface';
import { PartsOrderDialog } from '../../dialogs/parts-order-dialog/parts-order.dialog';
import { PartsOrderService } from '../../services/parts-order.service';
import { TaskService } from '../../services/task.service';
import { Task } from '@contracts/interfaces/task.interface';

@Component({
  selector: 'app-parts-ordered',
  templateUrl: './parts-ordered.component.html',
  styleUrls: ['./parts-ordered.component.scss']
})
export class PartsOrderedComponent implements OnInit {

  public orders: PartsOrder[] = [];
  public isLoading = false;
  public activeTab: 'ordered' | 'received' | 'shopping-list' = 'ordered';

  constructor(
    private dialog: MatDialog,
    private partsOrderService: PartsOrderService,
    private taskService: TaskService
  ) { }

  ngOnInit(): void {
    this.loadOrders();
  }

  loadOrders() {
    this.isLoading = true;
    this.partsOrderService.list().subscribe({
      next: (orders) => {
        this.orders = orders || [];
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  openDialog(order?: PartsOrder) {
    const dialogRef = this.dialog.open(PartsOrderDialog, {
      width: '720px',
      data: { order }
    });

    dialogRef.afterClosed().subscribe((result?: PartsOrder) => {
      if (!result) {
        return;
      }

      const payload = order ? { ...order, ...result } : result;
      const request$ = order
        ? this.partsOrderService.update(payload)
        : this.partsOrderService.create(payload);

      request$.subscribe(() => this.loadOrders());
    });
  }

  setTab(tab: 'ordered' | 'received' | 'shopping-list') {
    this.activeTab = tab;
  }

  get orderedOrders(): PartsOrder[] {
    return (this.orders || []).filter(o => o.status !== PartsOrderStatus.RECEIVED);
  }

  get receivedOrders(): PartsOrder[] {
    return (this.orders || []).filter(o => o.status === PartsOrderStatus.RECEIVED);
  }

  get shoppingListOrders(): PartsOrder[] {
    return []; // TODO: Implement shopping list logic
  }

  get filteredOrders(): PartsOrder[] {
    switch (this.activeTab) {
      case 'ordered':
        return this.orderedOrders;
      case 'received':
        return this.receivedOrders;
      case 'shopping-list':
        return this.shoppingListOrders;
      default:
        return this.orderedOrders;
    }
  }

  openTask(order: PartsOrder) {
    const taskId = order.taskId ? Number(order.taskId) : null;
    if (!taskId) {
      return;
    }

    this.taskService.get(taskId).subscribe((task: Task | null) => {
      if (!task) {
        return;
      }

      this.taskService.openTaskDialog(task, [task.id], 0, () => {});
    });
  }

  toggleReceived(order: PartsOrder) {
    const isReceived = order.status === PartsOrderStatus.RECEIVED;
    const updated: PartsOrder = {
      ...order,
      status: isReceived ? PartsOrderStatus.ORDERED : PartsOrderStatus.RECEIVED,
      receivedDate: isReceived ? undefined : new Date()
    };

    this.partsOrderService.update(updated).subscribe(() => {
      this.loadOrders();
    });
  }

}
